/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResponseOfPtw100BadRequestException,
  ErrorResponseOfPtw100InternalServerException,
  ErrorResponseOfPtw100MaintenanceModeException,
  ErrorResponseOfPtw100NotFoundException,
  ErrorResponseOfPtw100UnauthorizedException,
  SmartCropMode,
} from '../models/index';
import {
    ErrorResponseOfPtw100BadRequestExceptionFromJSON,
    ErrorResponseOfPtw100BadRequestExceptionToJSON,
    ErrorResponseOfPtw100InternalServerExceptionFromJSON,
    ErrorResponseOfPtw100InternalServerExceptionToJSON,
    ErrorResponseOfPtw100MaintenanceModeExceptionFromJSON,
    ErrorResponseOfPtw100MaintenanceModeExceptionToJSON,
    ErrorResponseOfPtw100NotFoundExceptionFromJSON,
    ErrorResponseOfPtw100NotFoundExceptionToJSON,
    ErrorResponseOfPtw100UnauthorizedExceptionFromJSON,
    ErrorResponseOfPtw100UnauthorizedExceptionToJSON,
    SmartCropModeFromJSON,
    SmartCropModeToJSON,
} from '../models/index';

export interface GetProcessedImageRequest {
    fileId: string;
    smartCrop: SmartCropMode;
    width?: number;
    height?: number;
    aspectRatio?: number;
}

/**
 * 
 */
export class ImagesApi extends runtime.BaseAPI {

    /**
     * Gets a processed image with optional scaling and cropping, served as WebP format
     */
    async getProcessedImageRaw(requestParameters: GetProcessedImageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        if (requestParameters['fileId'] == null) {
            throw new runtime.RequiredError(
                'fileId',
                'Required parameter "fileId" was null or undefined when calling getProcessedImage().'
            );
        }


        if (requestParameters['smartCrop'] == null) {
            throw new runtime.RequiredError(
                'smartCrop',
                'Required parameter "smartCrop" was null or undefined when calling getProcessedImage().'
            );
        }


        const queryParameters: any = {};

        if (requestParameters['width'] != null) {
            queryParameters['width'] = requestParameters['width'];
        }

        if (requestParameters['height'] != null) {
            queryParameters['height'] = requestParameters['height'];
        }

        if (requestParameters['aspectRatio'] != null) {
            queryParameters['aspectRatio'] = requestParameters['aspectRatio'];
        }

        if (requestParameters['smartCrop'] != null) {
            queryParameters['smartCrop'] = requestParameters['smartCrop'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/images/{fileId}`.replace(`{${"fileId"}}`, encodeURIComponent(String(requestParameters['fileId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
         }, initOverrides);


				// ++ Responses
         switch (response.status) {
          case 200: { 
						return new runtime.BlobApiResponse(response);
					}
          case 400: { 
						return new runtime.BlobApiResponse(response);
					}
          case 401: { 
						return new runtime.BlobApiResponse(response);
					}
          case 403: { 
						return new runtime.BlobApiResponse(response);
					}
          case 404: { 
						return new runtime.BlobApiResponse(response);
					}
          case 500: { 
						return new runtime.BlobApiResponse(response);
					}
					default: {
						return new runtime.BlobApiResponse(response);
					}
				}
				// -- Responses
    }

    /**
     * Gets a processed image with optional scaling and cropping, served as WebP format
     */
     async getProcessedImage(requestParameters: GetProcessedImageRequest, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<ImagesApi['getProcessedImageRaw']>>, Blob>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = Blob;

         const response = this.getProcessedImageRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

}
